import React from 'react';
import PropTypes from 'prop-types';
import { capitalize, lowerCase } from 'lodash';
import { yardsToFurlongs } from '../../../utils/distance';
import { formatPrize } from '../../../utils/money';
import { CourseLink } from '../../../shared/links/ProfileLink';

const ConditionsCell = ({
    courseComments,
    courseStyleName,
    courseRpAbbrev3,
    distanceYard,
    goingTypeServicesDesc,
    courseUid,
    raceDescription,
    raceClass,
    prizeSterling,
    rpStraightRoundJubileeDesc: jubileeDesc,
    raceOutcomeCode,
    rpCloseUpComment,
}) => {
    const filteredJubileeDesc = jubileeDesc && lowerCase(jubileeDesc.replace(/oms\s?/i, ''));
    return (
        <span>
            <CourseLink
                courseStyleName={courseStyleName}
                courseUid={courseUid}
                title={courseComments}
                className="hp-formTable__course"
            >
                <span className="hidden-lg-down">{courseStyleName}</span>
                <span className="hidden-xl-up">{capitalize(courseRpAbbrev3)}</span>
            </CourseLink>
            {
                filteredJubileeDesc ? (
                    <span>
                        &nbsp;{filteredJubileeDesc}
                    </span>
                ) : null
            }
            <span className="hidden-sm-up">
                &nbsp;{yardsToFurlongs(distanceYard)} {goingTypeServicesDesc}
            </span>
            {raceClass ? ' C' : ' '}{raceDescription}
            <span className="hidden-xs-down">
                &nbsp;{formatPrize(prizeSterling)}
            </span>
            {(raceOutcomeCode === 'NR') &&
            <div>
                <strong className="nonRunnerSliderSwitcherData__exNarrow">
                    Non Runner{!!rpCloseUpComment && ` (${rpCloseUpComment})`}
                </strong>
            </div>}
        </span>
    );
};

ConditionsCell.propTypes = {
    courseComments: PropTypes.string,
    courseStyleName: PropTypes.string,
    courseRpAbbrev3: PropTypes.string,
    distanceYard: PropTypes.number,
    goingTypeServicesDesc: PropTypes.string,
    courseUid: PropTypes.number,
    raceDescription: PropTypes.string,
    raceClass: PropTypes.string,
    prizeSterling: PropTypes.number,
    rpStraightRoundJubileeDesc: PropTypes.string,
    raceOutcomeCode: PropTypes.string,
    rpCloseUpComment: PropTypes.string,
};

export default ConditionsCell;



// WEBPACK FOOTER //
// ./src/js/horse/form/formTable/ConditionsCell.jsx